import { createIdSlice } from '../utils/action/createElementSlice';
export const AutoInteractionState = createIdSlice({
    elementName: 'autoInteraction',
    initialState: {},
    reducers: {
        set: (_state, action) => {
            return action.payload.data;
        },
        deleteItem: (state, _action) => state,
        deleteValue: (state, _action) => state,
    },
});
